import type { ICampaignTableHeading } from '../types';

import { useGCampaignTableContext } from '../contexts';
import { GCampaignTable } from '../GCampaignTable';
import { createContext, useContext } from 'react';
import { Box } from '@shopify/polaris';

interface CellContextType<T extends string> {
  item: ICampaignTableHeading<T>;
  columnIndex: number;
}

const CellContext = createContext<CellContextType<string> | undefined>(undefined);

export const useGCampaignTableCellContext = <T extends string>(): CellContextType<T> => {
  const context = useContext(CellContext);
  if (!context) {
    throw new Error('useCellContext must be used within a CellContext.Provider');
  }
  return context as CellContextType<T>;
};

interface PropertyProps {
  children: React.ReactNode;
}

export const Property: React.FC<PropertyProps> = ({ children }) => {
  const { listHeader } = useGCampaignTableContext();

  return (
    <Box borderRadius="300" background="bg-fill-active" padding="0">
      <GCampaignTable.Row>
        {listHeader.map((property, columnIndex) => (
          <CellContext.Provider
            key={`property-${property.id}`}
            value={{ item: property, columnIndex }}
          >
            <GCampaignTable.Cell index={columnIndex}>{children}</GCampaignTable.Cell>
          </CellContext.Provider>
        ))}
      </GCampaignTable.Row>
    </Box>
  );
};
